var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":_vm.aviso.titulo}},[_c('b-card-text',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.aviso.descricao)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }